module.exports = __webpack_public_path__ + "static/img/4-2.0294c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/4-2.png
// module id = rKxB
// module chunks = 10